import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=10c1790a&scoped=true&"
import script from "./spinner.js?vue&type=script&lang=js&"
export * from "./spinner.js?vue&type=script&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=10c1790a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1790a",
  null
  
)

export default component.exports